/* eslint-disable react/jsx-props-no-spreading */
import type { VoidFunctionComponent } from 'react';
import type { RevisionDropdownProps } from './types';
import LegacyRevisionDropdown from '../../RevisionDropdown';
import { useIsFeatureEnabled } from '../../../../helpers/features';
import { HYBRID_PROJECTS } from '../../../../../shared/featureFlags/flagNames';
import RefreshedRevisionDropdown from './Dropdown';
import styles from './RevisionDropdown.module.less';

/**
 * Renders the revisions dropdown component based on the HYBRID_PROJECTS feature flag.
 */
const RevisionDropdown: VoidFunctionComponent<RevisionDropdownProps> = (props: RevisionDropdownProps) => {
  const isHybridProjectsEnabled = useIsFeatureEnabled(HYBRID_PROJECTS);

  if (isHybridProjectsEnabled) {
    return (
      <div className={`nav-project-description ${styles.revisionDropdown}`}>
        <RefreshedRevisionDropdown {...props} />
      </div>
    );
  }

  return (
    <p
      className="animated fadeInDown fast"
      style={{
        zIndex: 1,
        position: 'relative',
        color: '#fff',
        marginBottom: 0,
      }}
    >
      <span
        style={{
          position: 'relative',
          marginLeft: '-6px',
          marginTop: '-6px',
        }}
      >
        <LegacyRevisionDropdown {...props} />
      </span>
    </p>
  );
};

export default RevisionDropdown;
